<template>
    <div>
        <div class="search-box">
            <div class="input-item">
                <span class="label">变更时间</span>
                <DatePicker
                    type="daterange"
                    split-panels
                    separator="至"
                    :transfer="true"
                    placement="bottom"
                    format="yyyy-MM-dd"
                    placeholder="选择日期"
                    @on-change="searchParams.date = $event"
                >
                </DatePicker>
            </div>

            <!-- <div class="input-item">
                <span class="label">类型</span>
                <RadioGroup v-model="searchParams.operateType" @on-change="getInitList">
                    <Radio label="">
                        <span>全部</span>
                    </Radio>
                    <Radio label="2">
                        <span>编辑</span>
                    </Radio>
                    <Radio label="4">
                        <span>继承</span>
                    </Radio>
                </RadioGroup>
            </div> -->

            <div class="input-item">
                <span class="label">变更人</span>
                <Select v-model="searchParams.updateId" :transfer="true" clearable filterable>
                    <Option :value="item.createBy" v-for="(item, index) in changedByList" :key="index">{{ item.name }}</Option>
                </Select>
            </div>

            <div class="btn-item">
                <Button type="primary" @click="search()">搜索</Button>
            </div>
        </div>

        <div class="table-box template-table">
            <loading :isShow="tableLoading" />
            <Table :columns="columns" :data="tableData" v-if="tableData.length">
                <template slot-scope="{ row }" slot="beforeChange">
                    {{ row.oldValue }}
                </template>

                <template slot-scope="{ row }" slot="afterChange">
                    {{ row.newValue }}
                </template>
            </Table>
            <no-data v-else style="margin-top:10px;"></no-data>
        </div>

        <div class="pageBox">
            <Page
                :total="total"
                :current="searchParams.pageNo"
                :page-size="searchParams.pageSize"
                show-total
                @on-change="pageChange"
                style="text-align: center"
            />
        </div>
    </div>
</template>

<script>
import filters from '@/api/filter';
export default {
    name: 'salesman',
    props: ['policyNo'],
    data() {
        return {
            tableLoading: false,
            columns: [
                {
                    title: '序号',
                    type: 'index',
                    align: 'center',
                    width: 60
                },
                {
                    title: '名称',
                    key: 'fieldName',
                    align: 'center',
                    minWidth: 150,
                    ellipsis: true,
                    tooltip: true
                },
                // {
                //     title: '类型',
                //     align: 'center',
                //     minWidth: 80,
                //     render(h, params) {
                //         let operateType = params.row.operateType;
                //         if (operateType == 1) {
                //             return <span>新增</span>;
                //         } else if (operateType == 2) {
                //             return <span>编辑</span>;
                //         } else if (operateType == 3) {
                //             return <span>删除</span>;
                //         } else if (operateType == 4) {
                //             return <span>继承</span>;
                //         }
                //     }
                // },
                {
                    title: '变更前',
                    align: 'center',
                    minWidth: 240,
                    slot: 'beforeChange'
                },
                {
                    title: '变更后',
                    align: 'center',
                    minWidth: 240,
                    slot: 'afterChange'
                },
                {
                    title: '变更人',
                    align: 'center',
                    minWidth: 150,
                    render(h, params) {
                        const result = params.row.operator;
                        return <span>{result ? result : '-'}</span>;
                    }
                },
                {
                    title: '变更时间',
                    align: 'center',
                    minWidth: 150,
                    render(h, params) {
                        const result = params.row.createTime;
                        return <span>{filters.filterTime(result, 'YYYY-MM-DD HH:mm') || '-'}</span>;
                    }
                }
            ],
            tableData: [],
            changedByList: [],
            total: 0,
            searchParams: {
                pageNo: 1,
                pageSize: 10,
                type: '3'
            }
        };
    },

    methods: {
        // 处理请求参数
        setRequestParam() {
            let obj = JSON.parse(JSON.stringify(this.searchParams));
            if (obj.date && obj.date[0]) {
                obj.beginUpdateTime = filters.filterTime(obj.date[0], 'YYYY-MM-DD');
                obj.endUpdateTime = filters.filterTime(obj.date[1], 'YYYY-MM-DD');
            }
            obj.policyNo = this.policyNo;
            delete obj.date;
            let { ...params } = obj;
            return params;
        },

        getInitList() {
            this.tableLoading = true;
            this.$http({
                url: `/buz/policyChangeRecord/read/list`,
                type: 'POST',
                data: this.setRequestParam()
            })
                .then(res => {
                    this.tableData = res.data;
                    this.total = res.total;
                })
                .finally(() => {
                    this.tableLoading = false;
                });
        },

        // 获取变更人
        getChangedBy() {
            this.$http({
                url: `/buz/policyChangeRecord/selectUserInfo`,
                type: 'GET',
                data: {
                    policyNo:this.policyNo
                }
            }).then(res => {
                this.changedByList = res.data;
            });
        },

        // 搜索
        search() {
            this.searchParams.pageNo = 1;
            this.getInitList();
        },

        // 分页
        pageChange(pageNo) {
            this.searchParams.pageNo = pageNo;
            this.getInitList();
        }
    }
};
</script>

<style lang="scss" scoped>
.search-box {
    .input-item {
        width: 300px !important;
    }
}
</style>
